import React from "react";
import "./Legislators.css";
import Typography from "@mui/joy/Typography";
import Tabs from "@mui/joy/Tabs";
import TabList from "@mui/joy/TabList";
import Tab from "@mui/joy/Tab";
import ListItemDecorator from "@mui/joy/ListItemDecorator";
import Stack from "@mui/joy/Stack";
import ToggleButtonGroup from "@mui/joy/ToggleButtonGroup";
import Background from "../../hero-pattern.svg";
import { useEffect, useState } from "react";
import MemberList from "../../components/MemberList/MemberList";
import Loading from "../Loading";
import { IconButton, Input } from "@mui/joy";
import SearchIcon from "@mui/icons-material/Search";
import AccountBalanceIcon from "@mui/icons-material/AccountBalance";
import ListIcon from "@mui/icons-material/List";
import AppsIcon from "@mui/icons-material/Apps";

function Legislators() {
  const [loading, setLoading] = useState(false);
  const [members, setMembers] = useState([]);
  const [tab, setTab] = useState("senator");
  const [display, setDisplay] = useState("cards");
  const [search, setSearch] = useState("");

  useEffect(() => {
    document.title = `Legislators | Civic Engage`;
    if (localStorage.getItem(tab)) {
      setLoading(true);
      setMembers([]);
      var memberJson = localStorage.getItem(tab);
      var memberArr = JSON.parse(memberJson);
      setMembers(memberArr);
      setLoading(false);
    } else {
      setLoading(true);
      setMembers([]);
      fetch(`/api/member/${tab}`)
        .then((response) => response.json())
        .then((data) => {
          setMembers(data);
          localStorage.setItem(tab, JSON.stringify(data));
          setLoading(false);
        });
    }
  }, [tab]);

  return (
    <Stack
      className="hero-image"
      direction={"column"}
      sx={{
        alignItems: "stretch",
        backgroundImage: "url(" + Background + ")",
      }}
    >
      <Stack direction={"column"} padding={8} spacing={1}>
          <Typography level="h1" style={{ textAlign: "center" }}>
            The Faces Behind the Decisions
          </Typography>
          <Typography level="body-lg" style={{ textAlign: "center" }}>
            Discover who represents you in government. Stay informed, hold them
            accountable, and advocate for the issues that matter most to you.
          </Typography>
      </Stack>
      <Stack className="legislators-content" direction={"column"} spacing={2} sx={{alignItems: 'center'}}>
        <Stack spacing={2} sx={{ width: "100%" }}>
          <Tabs
            aria-label="Icon tabs"
            defaultValue={0}
            sx={{ width: "100%" }}
            value={tab}
            size="lg"
            onChange={(event, newValue) => setTab(newValue)}
          >
            <TabList>
              <Tab
                variant="plain"
                color="primary"
                value="senator"
                sx={{ width: "100%" }}
              >
                <ListItemDecorator>
                  <AccountBalanceIcon />
                </ListItemDecorator>
                Senators
              </Tab>
              <Tab
                variant="plain"
                color="primary"
                value="representative"
                sx={{ width: "100%" }}
              >
                <ListItemDecorator>
                  <AccountBalanceIcon />
                </ListItemDecorator>
                House Representatives
              </Tab>
            </TabList>
          </Tabs>
        </Stack>

        <Stack
          className="filter-container"
          direction={"row"}
          spacing={1}
          padding={2}
          sx={{ justifyContent: "space-between", alignItems: "center", width: "100%", maxWidth: '1260px' }}
        >
          <Input
            placeholder="Search for a representative by name or state"
            startDecorator={<SearchIcon />}
            value={search}
            onChange={(event, newValue) => {
              setSearch(event.target.value);
            }}
            sx={{ width: "50%" }}
          />
          <ToggleButtonGroup
            value={display}
            onChange={(event, newValue) => {
              setDisplay(newValue);
            }}
          >
            <IconButton value="cards">
              <AppsIcon />
            </IconButton>
            <IconButton value="list">
              <ListIcon />
            </IconButton>
          </ToggleButtonGroup>
        </Stack>
        {loading && members.length === 0 ? (
          <Loading></Loading>
        ) : (
          <MemberList members={members} display={display} search={search} tab={tab} />
        )}
      </Stack>
    </Stack>
  );
}

export default Legislators;
